"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VisuallyHidden_meta_1 = require("../VisuallyHidden.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', VisuallyHidden_meta_1.VISUALLYHIDDEN_CATEGORY_KEY, VisuallyHidden_meta_1.VISUALLYHIDDEN_COMPONENT_KEY, ['wrapper']);